<template>
  <div>
    <navbarcold></navbarcold>
    <div class="container" style="margin-top: 3rem;">
      <h2>Step 3: Switch to your Primary Laptop</h2>
      <p>On your <b>Primary</b> laptop open <b>Firefox</b> and type the following URL into the address bar and click <b>Enter</b>.</p>
      <code>three.yeticold.com</code>
    </div>
  </div>
</template>
<script>
import navbarcold from './navbarcold'
export default {
  components: {
    navbarcold
  }
}
</script>





// WEBPACK FOOTER //
// src/components/YCSetup3.vue